import InputLabelWrapper from "components/basic/input-label-wrapper/InputLabelWrapper";
import { MdmProjectDto } from "gql/generated/types";
import { InputSwitch } from "primereact/inputswitch";
import React from "react";
import { T } from "services/lang/LanguageService";

type AntennasConfigurationProps = {
  projectConfig: MdmProjectDto | null;
  setProjectConfig: React.Dispatch<React.SetStateAction<MdmProjectDto | null>>;
}

const AntennasConfiguration: React.FC<AntennasConfigurationProps> = ({ projectConfig, setProjectConfig }) => {
  return (
    <div className="p-fluid grid mb-4">
      <InputLabelWrapper labelName={T("word.visible")} col={2} flexDirection="column" className="gap-2">
        <InputSwitch
          checked={Boolean(projectConfig?.configuration?.antennasConfiguration.visible)}
          onChange={e =>
            setProjectConfig(prev => ({
              ...prev!,
              configuration: {
                ...prev?.configuration!,
                antennasConfiguration: { visible: e.value },
              },
            }))
          }
          className="p-inputtext-sm"
        />
      </InputLabelWrapper>
    </div>
  );
}

export default AntennasConfiguration;